import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'
import Scroll from 'vue-seamless-scroll'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import { Swipe, SwipeItem, Tab, Tabs } from 'vant';
import cetihuan from './utils/cetihuan.js'
import VueAMap from 'vue-amap'
 
import '@/assets/fonts/MSYH.TTF'
import '@/assets/fonts/MSYHBD.TTF'

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo);

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);

Vue.prototype.$video = Video;
Vue.prototype.$cetihuan = cetihuan;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: "VH2cwEGJaakWJUaeuHRD72PpJLYCxzEg"
})
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  // 高德的key
  key: 'd8616804850f4928aa2fc757e4926844',
  // 插件集合
  plugin: [
    'AMap.CircleEditor',// 圆形编辑器插件
    "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
    "AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.CitySearch",
    "AMap.Scale",
    "AMap.HawkEye",
    "AMap.ToolBar",
    "AMap.ControlBar",
    "AMap.MouseTool",
    "AMap.DragRoute",
    "AMap.MoveAnimation"
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
});
//高德的安全密钥
window._AMapSecurityConfig = {
	securityJsCode:'28de7e968839833dc339aa7f82f96e23',
}
Vue.use(Scroll);


// 正式环境清除所有console.log
// if (window) {
//   window.console.log = function () { };
// }



new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
  	document.dispatchEvent(new Event('render-event'))
	// document.dispatchEvent(new Event('custom-render-trigger'))
	// document.dispatchEvent(new Event('prerender'))
  }
}).$mount('#app')
